<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">Macraweave</h1>
<h2 class="description">Macramé meets weaving with<br/>18 stunning home decor projects</h2>
<p class="author">AMY MULLINS &amp;<br/>MARNIA RYAN-RAISON</p>
<p class="logo"><img alt="" src="images/logo.gif"/></p>
<p class="publisher"><a href="http://www.davidandcharles.com" target="_blank">www.davidandcharles.com</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?7eadd3ce